/* eslint-disable @next/next/no-img-element */
import { getAssets } from "@unisearch/helpers";
import Image from "next/legacy/image";
import Link from "next/link";
import React from "react";
import styles from "./vlog_category_card.module.scss";

export const VlogCategoryCard = ({ item }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.image_wrapper}>
        {/* <img src={item?.featureImage?.src} alt={item?.featureImage?.alt} /> */}
        <Image
          layout="responsive"
          width={304}
          height={280}
          blurDataURL={getAssets("assets/images/image_placeholder_big.webp")}
          placeholder="blur"
          className=""
          src={
            item?.featureImage?.src ||
            getAssets("assets/images/image_placeholder_big.webp")
          }
          alt={item?.title}
        />
      </div>
      <div className={styles.details}>
        <Link legacyBehavior href={`/vlog/category/${item?.slug}`}>
          <a className={styles.title}>{item?.title}</a>
        </Link>
        <div className={styles.sub_title}>{item?.videos} Videos</div>
      </div>
    </div>
  );
};

export default VlogCategoryCard;
